/**
 * Storage item keys.
 * Keep all defined here since using enum.
 */
export enum Store {
    ID = 'x-id',
    OPT_OUT_POL = 'political-ad-opt-out',
    PPID = 'ppid',
    LR_TOKEN_KEY = 'LRTokenKey',
    JWT = 'lr_jwt',
    REDIRECT_URL = 'redirect_url',
    PIANO_PARAMS = 'piano_params',
    VF_ACCESS = 'vfAccess',
    VF_REFRESH = 'vfRefresh',
    VF_COMMENT_TEXT = 'vfCommentText',
    LR_USER_UID = 'lr-user-uid',
    LR_USER = 'LoginRadiusUser',
    GNS_USER_STATE = 'gnsUserState', // google news showcase user state
    GNS_REDIRECT_URL = 'gnsRedirectUrl' // google news showcase redirect url after login
}
